import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";

const RSA_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAu1idv0AXiPWXs7eCmxcM
kJJfBdKTdJ5n85yOm5uWqWhRoXhlSyEB8rtovPGlk8K+OmcF/rMcx4G2s38ol4/G
lW6pAw16/nH2XsVZWD5zPHXFT8/FG+nomMKpD++3DhaAuEWW7XE/1x5oAiubqj3V
J6Hd5Q7PRvE8krDOJFlZ0Q0u91uciDlt0i4R4F71LyHOSOHbyl5UW5Kepb9pfwRz
/wlIhUz2EqE5zmmSQaYkolL+YzUPt0BBTlptrOrbRDEmmQ45VTiMtKLZlVwwUfst
lRdx/iTvHNJE34/iEgMQOUkHnURZQ8u3Kw2mJ+a7xKOcXI8WFFcjqq3TjAQtZVdB
5QIDAQAB
-----END PUBLIC KEY-----`;

function generateRandomAESKey(length = 16) {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += charset.charAt(Math.floor(Math.random() * charset.length));
  }
  return result;
}

export function encryptDataHybrid(dataToEncrypt) {
  try {
    // ✅ Step 1: Create a fixed or generated 16-character key (safe for UTF-8)
    const aesKeyString = generateRandomAESKey(); // e.g., "a3Dx7F9bL0tYkQ2z"

    // ✅ Step 2: Convert to WordArray
    const rawKey = CryptoJS.enc.Utf8.parse(aesKeyString);

    // ✅ Step 3: Encrypt JSON payload
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(dataToEncrypt),
      rawKey,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    const encryptedData = encrypted.toString(); // Base64

    // ✅ Step 4: Encrypt the AES key using RSA
    const rsa = new JSEncrypt();
    rsa.setPublicKey(RSA_PUBLIC_KEY);
    const encryptedKey = rsa.encrypt(aesKeyString); // Now safe

    if (!encryptedKey) throw new Error("RSA encryption failed");

    return {
      encryptedData,
      encryptedKey,
    };
  } catch (err) {
    console.error("🛑 Encryption failed:", err.message);
    return null;
  }
}

